var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root",staticStyle:{"width":"100%","overflow":"auto","margin-bottom":"1rem"}},[_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
      callback: _vm.onVisible,
      intersection: {
        rootMargin: '400px',
        threshold: 0.125
      }
    }),expression:"{\n      callback: onVisible,\n      intersection: {\n        rootMargin: '400px',\n        threshold: 0.125\n      }\n    }"}],staticClass:"context has-background-white-ter",style:({
      display: 'block',
      width: `${_vm.screenWidth}px`,
      height: `${_vm.screenHeight}px`
    })},[(_vm.source !== null)?_c('img',{style:({
        display: 'block',
        width: '100%',
        height: `${_vm.screenHeight}px`
      }),attrs:{"src":_vm.source},on:{"error":_vm.onError}}):_vm._e(),_vm._l((_vm.results),function(item){return _c('Highlight',_vm._b({key:item.id,attrs:{"is-primary":true}},'Highlight',item,false))})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }